export default __webpack_public_path__ + "static/media/paragon-logo-full-page.40970ca5.png";